import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetClientListNetwork,
  getMonthsYearsAction,
} from "../../../redux/actions/GlobalAction";
import Select from "react-select";
import { getAllProviderListNetworkAction } from "../../../redux/actions/TestPackageNetworkAction";
import { placeholderSelectColor } from "../NetworkIntelligence/UsageCoverage/helper";
import { InputOptionSelect } from "../../../common/InputOptionSelect";
import { TotalProveiderMonth, initialFilterStateForPayable } from "./helper";
import Modal from "react-modal";
import { SearchIcon } from "../../../Utils/SvgIcons";
import "../../../assets/css/payout.css";
import PaginatedItems from "../../../common/Pagination";
import { BankDetails } from "./BankDetails";
import { API_URL_WITHOUT_USER } from "../../../Utils/API";
import { getNetworkMenuId, getToken } from "../../../Utils/types";
import CustomPagination from "../../../common/CustomPagination";

import { getSnackbarSuccess, isLoadingAction } from "../../../Utils/helper";
import {
  AddUpdateAdvancePaymentFlowNetwork,
  AdvancePaymenViewHistory,
  GetAdvancePaymentFlow,
  GetAdvancePaymentFlowCaseNo,
} from "../../../redux/actions/PayoutAction";
import AdvancePaymentEditModel from "./AdvancePaymentEditModel";
import AdditionalComponentHeader from "../../helperComponent/AdditionalComponentHeader";
import { HistoryDetailsPopup } from "../ProviderProfileDetails/HistoryDetailsPopup";
import UnlockHistory from "../../helperComponent/UnlockHistory";
import AdvancePaymentPayout from "./AdvancePaymentPayout";
import Datetime from "react-datetime";
import { isValidDate } from "../../ServicePortal/ProfileDetail/helper";
import moment from "moment";

export const AdvancePayment = () => {
  const [providerValues, setProviderValues] = useState(null);
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const [isOpenModelForEdit, setIsOpenModelForEdit] = useState(false);
  const [inputClient, setInputClient] = useState("");
  const [searchFilter, setSearchFilter] = useState(
    initialFilterStateForPayable
  );
  const [providerDetail, setProviderDetail] = useState([]);
  const [month, setMonth] = useState(null);
  // const [header, setHeader] = useState([]);
  const [client, setClient] = useState(null);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [submitUtr, setSubmitUtr] = useState({ isOpen: false, rowData: null });
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
  const dispatch = useDispatch();
  const [header, setHeader] = useState([
    {
      label: "Provider Name",
      col: "providerName",
      show: true,
      default: true,
      index: 0,
    },
    { label: "Case No", col: "caseNo", show: true, default: true, index: 1 },
    {
      label: "Policy Ref No",
      col: "policyRefNo",
      show: true,
      default: true,
      index: 2,
    },
    {
      label: "Docket No.",
      col: "docketNo",
      show: true,
      default: true,
      index: 3,
    },

    {
      label: "Adv DC Amount",
      col: "advancedDCAmt",
      show: true,
      default: true,
      index: 4,
    },
    {
      label: "Adv Insurer Amount",
      col: "advancedInsurerAmt",
      show: true,
      default: true,
      index: 5,
    },
    {
      label: "Customer Name",
      col: "customerName",
      show: false,
      default: false,
      index: 6,
    },

    {
      label: "Payment Type",
      col: "paymentType",
      show: false,
      default: false,
      index: 7,
    },
    {
      label: "Adv HV Amount",
      col: "advanceInsurerHomeVisitAmount",
      show: false,
      default: false,
      index: 8,
    },
    {
      label: "Account No.",
      col: "accountNumber",
      show: false,
      default: false,
      index: 9,
    },
    {
      label: "Bank Name",
      col: "bankName",
      show: false,
      default: false,
      index: 10,
    },
    {
      label: "IFSC Code",
      col: "ifscCode",
      show: false,
      default: false,
      index: 11,
    },
    {
      label: "Payee Name",
      col: "payeeName",
      show: false,
      default: false,
      index: 12,
    },
    {
      label: "PAN Number",
      col: "panNumber",
      show: false,
      default: false,
      index: 13,
    },
    {
      label: "Payment Mode",
      col: "paymentMode",
      show: false,
      default: false,
      index: 14,
    },
    { label: "UTR", col: "utr", show: false, default: false, index: 15 },
    {
      label: "TDS Flag",
      col: "tdsFlag",
      show: false,
      default: false,
      index: 16,
    },
    {
      label: "TDS %",
      col: "tdsPercentage",
      show: false,
      default: false,
      index: 17,
    },
    {
      label: "TDS Amount",
      col: "tdsAmount",
      show: false,
      default: false,
      index: 18,
    },
    {
      label: "Net Amount",
      col: "netAmount",
      show: false,
      default: false,
      index: 19,
    },
    {
      label: "Updated By",
      col: "updatedBy",
      show: false,
      default: false,
      index: 20,
    },
    {
      label: "Updated Date",
      col: "updateDateTime",
      show: false,
      default: false,
      index: 21,
    },
    {
      label: "Appointment Status",
      col: "appointmentStatus",
      show: false,
      default: false,
      index: 22,
    },
    { label: "Status", col: "status", show: true, default: true, index: 23 },
  ]);
  const [rowDetails, setRowDetails] = useState({});
  const [originalRowDetails, setOriginalRowDetails] = useState({});

  const rowDetailsChangeHandler = (name, value) => {
    setRowDetails({
      ...rowDetails,
      [name]: value,
    });
  };

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  const [selectAll, setSelectAll] = useState(false);
  const [selectAllFlag, setSelectAllFlag] = useState(false);

  const [screen, setScreen] = useState("first");

  useEffect(() => {
    dispatch(
      GetClientListNetwork({ clientId: 0, clientName: "", BusinessType: "IBU" })
    );
    dispatch(getMonthsYearsAction());
    dispatch(getAllProviderListNetworkAction());
    dispatch(GetAdvancePaymentFlow(searchFilter));
  }, []);

  useEffect(() => {
    if (searchFilter?.advPaymentStatus !== "Payment Approved") {
      setSearchFilter({
        ...searchFilter,
        year: null,
        month: null,
      });
    } else {
      setSearchFilter({
        ...searchFilter,
        year: moment().year().toString(),
        month: null,
      });
    }
  }, [searchFilter?.advPaymentStatus]);

  const handleSearch = () => {
    searchFilter.page = 1;
    dispatch(GetAdvancePaymentFlow(searchFilter));
    setProviderDetail([]);
    setSelectAll(false);
    setSelectAllFlag(false);
  };

  const handleSorting = async (type) => {
    changeHandler("SortDirection", type);
    dispatch(
      GetAdvancePaymentFlow({
        ...searchFilter,
        SortDirection: type,
      })
    );
  };

  const downloadFile = (ele) => {
    isLoadingAction(true, dispatch);
    setIsLoadingExcel(true);
    let prvid = providerDetail.map((ele) => ele?.providerId);
    let payIds = providerDetail.map((ele) => {
      return ele?.payId;
    });

    const url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelAdvancePaymentFlowNetwork`;
    let data = {
      ...searchFilter,
      isExportToExcel: true,
      appointmentIds: selectAll
        ? []
        : providerDetail?.map((i) => {
            return {
              appointmentId: i?.appointmentId,
            };
          }),
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        isLoadingAction(false, dispatch);
        const filename = "ProviderPayoutDetails.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
        setSelectAll(false);
        setSelectAllFlag(false);
        setProviderDetail([]);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
        setSelectAll(false);
        setSelectAllFlag(false);
      });
  };

  const handleClear = () => {
    setProviderDetail([]);
    setClient(null);
    setProviderValues(null);
    setInputClient("");
    setSearchFilter(initialFilterStateForPayable);
    setSelectAll(false);
    setSelectAllFlag(false);
    setMonth(new Date().getMonth + 1);
    dispatch(GetAdvancePaymentFlow(initialFilterStateForPayable));
  };
  const OnRowDetailsIndexChangeHandler = async (rowDetails, flag, closeRef) => {
    if (flag === "clear") {
      setRowDetails(originalRowDetails);
    } else if (flag === "submit") {
      const data = {
        appointmentId: rowDetails?.appointmentId,
        providerId: rowDetails?.providerId,
        advPaymentStatus: rowDetails?.status,
        advancedDCAmt: rowDetails?.advancedDCAmt,
        advancedInsurerAmt: rowDetails?.advancedInsurerAmt,
        utr: rowDetails?.utr,
        remarks: rowDetails?.remarks,
      };

      const ress = await dispatch(AddUpdateAdvancePaymentFlowNetwork(data));
      console.log("ress", ress);
      if (ress?.data?.status === true) {
        getSnackbarSuccess("success", ress?.data?.message, dispatch);
        setIsOpenModelForEdit(false);
        searchFilter.page = 1;
        setTimeout(() => {
          dispatch(GetAdvancePaymentFlow(searchFilter));
        }, 1000);
      } else {
        getSnackbarSuccess("error", ress?.data?.message, dispatch);
      }
    }
  };
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const [historySearch, setHistorySearch] = useState({
    page: 1,
    rows: 10,
    sortDirection: "DESC",
    caseNo: "BAGIC0007089",
    providerId: 0,
  });

  const [historyHeaders, setHistoryHeaders] = useState([
    { label: "Case No", col: "caseNo", show: true, default: true, index: 0 },
    {
      label: "Provider Name",
      col: "providerName",
      show: true,
      default: true,
      index: 1,
    },
    {
      label: "Adv DC Amount",
      col: "advancedDCAmt",
      show: true,
      default: true,
      index: 2,
    },
    {
      label: "Adv Insurer Amount",
      col: "advancedInsurerAmt",
      show: true,
      default: true,
      index: 3,
    },
    { label: "UTR", col: "utr", show: true, default: true, index: 4 },
    { label: "Status", col: "status", show: true, default: true, index: 5 },
    {
      label: "Updated By",
      col: "updatedBy",
      show: true,
      default: true,
      index: 6,
    },
    {
      label: "Updated Date Time",
      col: "updateDateTime",
      show: true,
      default: true,
      index: 7,
      type: "date",
    },
    {
      label: "Provider Remarks",
      col: "remarks",
      show: true,
      default: true,
      index: 8,
    },
    {
      label: "Insurer Remarks",
      col: "insurerRemarks",
      show: true,
      default: true,
      index: 9,
    },
    {
      label: "Payment Remarks",
      col: "paymentRemarks",
      show: true,
      default: true,
      index: 10,
    },
    {
      label: "Rejected Remarks",
      col: "rejectRemarks",
      show: true,
      default: true,
      index: 10,
    },
    {
      label: "Rejected By",
      col: "rejectedBy",
      show: true,
      default: true,
      index: 10,
    },
  ]);
  const [paymentDetails, setPaymentDetails] = useState(null);

  useEffect(() => {
    console.log("paymentDetails", paymentDetails);
  }, [paymentDetails]);

  return (
    <div className="right-section  pt-3" style={{ padding: "10px" }}>
      <div className="card staff-details-section">
        {screen !== "first" ? (
          <AdvancePaymentPayout
            paymentDetails={paymentDetails}
            setPaymentDetails={setPaymentDetails}
            setScreen={setScreen}
            handleSearch={handleSearch}
          />
        ) : (
          <div className="card-body">
            <h4 className="pt-1">Advance Payment</h4>
            <div className="mt-3 d-flex flex-wrap gap-3  ">
              <div className="payputMultiSelect">
                <Select
                  placeholder="Provider Name/Code"
                  className="basic-multi-select usagecoverage-search"
                  classNamePrefix="select"
                  isMulti
                  styles={placeholderSelectColor}
                  closeMenuOnSelect={false}
                  name="colors"
                  inputValue={providerValues?.input}
                  onInputChange={(value, action) => {
                    if (action.action === "input-change") {
                      setProviderValues({
                        ...providerValues,
                        input: value,
                      });
                    }
                    if (action.action === "menu-close") {
                      setProviderValues({
                        ...providerValues,
                        input: "",
                      });
                    }
                  }}
                  onChange={(event) => {
                    changeHandler(
                      "providerIds",
                      event.map((e) => e.value).toString()
                    );
                    setProviderValues({
                      ...providerValues,
                      options: event,
                    });
                  }}
                  value={
                    searchFilter?.providerIds === ""
                      ? null
                      : providerValues?.option
                  }
                  options={TestPackageReducer?.getProviderListNetworkDetails?.map(
                    (ele) => {
                      return {
                        value: ele?.providerId,
                        label: ele?.providerName,
                      };
                    }
                  )}
                  hideSelectedOptions={false}
                  components={{
                    Option: InputOptionSelect,
                  }}
                />
              </div>
              <div className="payputMultiSelect">
                <select
                  name="BusinessType"
                  style={{ height: "60px" }}
                  className="white-form-select "
                  value={
                    searchFilter?.advPaymentStatus
                      ? searchFilter?.advPaymentStatus
                      : ""
                  }
                  onChange={(e) => {
                    setSearchFilter({
                      ...searchFilter,
                      advPaymentStatus: e.target.value ? e.target.value : null,
                    });
                  }}
                >
                  <option value="">Select Status</option>
                  <option value="Pending At Manager">Pending At Manager</option>
                  <option value="Pending At Network">Pending At Network</option>
                  <option value="Pending At Network Account">
                    Pending At Network Account
                  </option>
                  <option value="Pending At Finance">Pending At Finance</option>
                  <option value="Payment Approved">Payment Approved</option>
                </select>
              </div>
              {searchFilter?.advPaymentStatus === "Payment Approved" && (
                <div className="payoutBussinessType">
                  <Datetime
                    dateFormat="YYYY"
                    timeFormat={false}
                    className="page-content payoutYearFilter"
                    isValidDate={isValidDate}
                    value={searchFilter?.year}
                    placeholder="Select Year"
                    closeOnSelect={true}
                    onChange={(e) =>
                      setSearchFilter({
                        ...searchFilter,
                        year: e?.format("YYYY"),
                      })
                    }
                  />
                </div>
              )}
              {searchFilter?.advPaymentStatus === "Payment Approved" && (
                <div className="payoutBussinessType">
                  <select
                    name="BusinessType"
                    className="white-form-select "
                    style={{ height: "60px" }}
                    value={month}
                    onChange={(e) => {
                      setMonth(e.target.value);
                      setSearchFilter({
                        ...searchFilter,
                        month: e.target.value ? e.target.value : null,
                      });
                    }}
                  >
                    <option value=""> Select Month</option>
                    {globalReducer?.getMonthYear?.lstMonths?.map((ele) => {
                      return (
                        <option value={+ele?.monthId}>{ele?.monthName}</option>
                      );
                    })}
                  </select>
                </div>
              )}
              <div className="payoutBussinessType">
                <input
                  style={{ height: "60px" }}
                  placeholder="Case No/Policy Ref. No/Docket No."
                  value={searchFilter?.caseNo ? searchFilter?.caseNo : ""}
                  className=" white-form-select  networkInputCaseNo"
                  onChange={(e) =>
                    changeHandler("caseNo", e.target.value.trim(" "))
                  }
                />
              </div>
            </div>
            <div className="row-results ">
              <div className="me-5 d-flex gap-1">
                <select
                  className="row-selectdropdown"
                  value={searchFilter?.rows}
                  onChange={(e) => {
                    setSearchFilter({
                      ...searchFilter,
                      page: 1,
                      rows: e.target.value,
                    });
                    dispatch(
                      GetAdvancePaymentFlow({
                        ...searchFilter,
                        rows: e.target.value,
                        page: 1,
                      })
                    );
                    // handleDataCount(e);
                  }}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <p className="results">
                  Total <span>{globalReducer?.getTotalCount}</span> results
                </p>
              </div>
              <div className="d-flex gap-2">
                <button
                  className="search"
                  type="button"
                  style={{ border: "none" }}
                  onClick={handleSearch}
                >
                  <a className="sidebar-links">
                    <SearchIcon />
                    <span className="sidebar-link-text">Search</span>
                  </a>
                </button>
                <button
                  className="search"
                  type="button"
                  style={{ border: "none" }}
                  onClick={() => handleClear("CBU")}
                >
                  <a className="sidebar-links">
                    <span className="sidebar-link-text">Clear All</span>
                  </a>
                </button>
                <button
                  className="btn search__btn"
                  type="button"
                  style={{ border: "none" }}
                  disabled={providerDetail?.length < 2}
                  // style={{ minWidth: "inherit" }}
                  onClick={downloadFile}
                >
                  <i className="fa-solid fa-arrow-down"></i> &nbsp; Export To
                  Excel
                </button>

                <button
                  className="dropdown-toggle appointment-dropdown "
                  // style={{ width: "160px" }}
                  type="button"
                  id="ascDescPayableBtn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="sidebar-link-text">
                    {searchFilter?.SortDirection === "asc"
                      ? "Ascending Order"
                      : "Descending Order"}
                  </span>
                  <span className="sidebar-link-text">
                    <i className="fa fa-list"></i>
                  </span>
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="ascDescPayableBtn"
                >
                  <li>
                    <button
                      className="dropdown-item btn-border-bottom"
                      type="button"
                      onClick={() => handleSorting("asc")}
                    >
                      Ascending Order
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      type="button"
                      onClick={() => handleSorting("desc")}
                    >
                      Descending Order
                    </button>
                  </li>
                </ul>
                <button
                  className="search__btn ascDescBtn p-2"
                  id="ascDescPayableBtn"
                  onClick={() => setIsOpenSetting(true)}
                  type="button"
                >
                  &nbsp;
                  <i class="fa-solid fa-gear" style={{ fontSize: "20px" }}></i>
                </button>
              </div>
            </div>
            <div className="select_all_div m-2">
              {providerDetail?.length > 0 && (
                <>
                  {!selectAll && (
                    <>
                      <p>{providerDetail?.length} Appointments are selected</p>
                      {globalReducer?.getTotalCount > searchFilter.rows && (
                        <>
                          {selectAllFlag === true && (
                            <span
                              className="select_all_primary_cases"
                              onClick={() => setSelectAll(true)}
                            >
                              Select all {globalReducer?.getTotalCount}{" "}
                              Appointments
                            </span>
                          )}
                        </>
                      )}
                    </>
                  )}
                  {selectAll && (
                    <p>
                      {globalReducer?.getTotalCount} Appointments are selected
                    </p>
                  )}
                </>
              )}
            </div>
            <div className="table-responsive __custom__properties">
              <table className="table" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th scope="col">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={
                          payoutReducer?.getAdvancePaymentFlow?.length ===
                          providerDetail?.length
                        }
                        onClick={(e) => {
                          e.target.checked
                            ? setProviderDetail(
                                payoutReducer?.getAdvancePaymentFlow
                              )
                            : setProviderDetail([]);
                          setSelectAll(false);
                          setSelectAllFlag(true);
                        }}
                        readOnly
                      />
                    </th>
                    {header
                      .filter((ele) => ele?.show === true)
                      ?.map((elee) => {
                        return (
                          <th
                            style={{
                              textAlign:
                                elee?.label !== "Provider Name" ? "center" : "",
                            }}
                          >
                            {elee?.label}
                          </th>
                        );
                      })}
                    <th style={{ textAlign: "center" }}>Action</th>
                    <th style={{ textAlign: "center" }}>History</th>
                    <th style={{ textAlign: "left" }}>Documents</th>
                  </tr>
                </thead>
                {payoutReducer?.getAdvancePaymentFlow?.length !== 0 && (
                  <tbody>
                    {payoutReducer?.getAdvancePaymentFlow?.map((ele, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={providerDetail.some(
                                (item) => ele === item
                              )}
                              onClick={(e) => {
                                if (e.target.checked) {
                                  setProviderDetail([...providerDetail, ele]);
                                } else {
                                  setProviderDetail(
                                    providerDetail?.filter(
                                      (item) => ele !== item
                                    )
                                  );
                                }
                                setSelectAll(false);
                                setSelectAllFlag(false);
                              }}
                            />
                          </td>
                          {header
                            ?.filter((ele) => ele?.show === true)
                            ?.map((coll) => {
                              return (
                                <td
                                  style={{
                                    textAlign:
                                      coll?.label !== "Provider Name"
                                        ? "center"
                                        : "",
                                    backgroundColor: ele?.isRejected
                                      ? "rgb(253, 233, 233)"
                                      : "",
                                  }}
                                >
                                  {" "}
                                  {coll?.label === "Status" ? (
                                    <div
                                      className="width-120"
                                      style={{ textAlign: "center" }}
                                    >
                                      {ele?.requestStatus !== "" && (
                                        <p
                                          className={`status-style ${
                                            ele?.status === "Payment Approved"
                                              ? "approved"
                                              : ele?.status ===
                                                "Pending At Finance"
                                              ? "pendingAtFinance"
                                              : ele?.status ===
                                                "Pending At Manager"
                                              ? "refundStatus"
                                              : ele?.status ===
                                                "Pending At Network Account"
                                              ? "pendingForpayment"
                                              : "pending"
                                          }`}
                                        >
                                          <div>{ele[coll?.col]}</div>
                                        </p>
                                      )}
                                    </div>
                                  ) : (
                                    <div style={{ width: "170px" }}>
                                      {coll?.label === "Updated Date"
                                        ? ele[coll?.col]?.split("T")[0]
                                        : ele[coll?.col]}
                                    </div>
                                  )}
                                </td>
                              );
                            })}

                          <td
                            style={{
                              backgroundColor: ele?.isRejected
                                ? "rgb(253, 233, 233)"
                                : "",
                            }}
                          >
                            <button
                              className="btn search__btn"
                              onClick={async () => {
                                console.log(
                                  "payoutReducer?.getInformationAccess",
                                  payoutReducer?.getInformationAccess
                                );

                                const index =
                                  payoutReducer?.getInformationAccess?.findIndex(
                                    (i) =>
                                      i?.informationName === ele?.status &&
                                      payoutReducer?.getInformationAccess
                                        ?.length !== 4
                                  );
                                if (
                                  index === -1 &&
                                  ele?.status !== "Payment Approved" &&
                                  !(
                                    payoutReducer?.getInformationAccess
                                      ?.length === 4 &&
                                    ele?.status === "Pending At Finance"
                                  )
                                ) {
                                  getSnackbarSuccess(
                                    "error",
                                    "You have no permission for :- " +
                                      ele?.status,
                                    dispatch
                                  );
                                  return;
                                }
                                setScreen("second");
                                const ress = await dispatch(
                                  GetAdvancePaymentFlowCaseNo({
                                    caseNo: ele?.caseNo,
                                    providerId: ele?.providerId,
                                    appointmentId: ele?.appointmentId,
                                  })
                                );
                                console.log("ress", ress);
                                setPaymentDetails(ress?.data?.results[0]);
                              }}
                            >
                              {ele?.status === "Payment Approved"
                                ? "View"
                                : "Edit"}
                            </button>
                          </td>

                          <td
                            style={{
                              backgroundColor: ele?.isRejected
                                ? "rgb(253, 233, 233)"
                                : "",
                            }}
                          >
                            <p
                              style={{ cursor: "pointer", color: "blue" }}
                              onClick={() => {
                                setIsHistoryOpen(true);
                                dispatch(
                                  AdvancePaymenViewHistory({
                                    ...historySearch,
                                    caseNo: ele?.caseNo,
                                    providerId: ele?.providerId,
                                    appointmentId: ele?.appointmentId,
                                  })
                                );
                              }}
                            >
                              {"View"}
                            </p>
                          </td>
                          <td
                            style={{
                              backgroundColor: ele?.isRejected
                                ? "rgb(253, 233, 233)"
                                : "",
                            }}
                          >
                            <div>
                              {ele?.filePath !== "" && ele?.filePath && (
                                <a href={ele?.filePath} target="_blank">
                                  <p style={{ color: "blue" }}> DC_doc</p>
                                </a>
                              )}
                              {ele?.insurerFilePath !== "" &&
                                ele?.insurerFilePath && (
                                  <a
                                    href={ele?.insurerFilePath}
                                    target="_blank"
                                  >
                                    <p style={{ color: "blue" }}>
                                      {" "}
                                      Insurer_doc
                                    </p>
                                  </a>
                                )}
                              {ele?.qrCodeFilePath !== "" &&
                                ele?.qrCodeFilePath && (
                                  <a href={ele?.qrCodeFilePath} target="_blank">
                                    <p style={{ color: "blue" }}> QRCode_doc</p>
                                  </a>
                                )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                )}
              </table>
            </div>
            {payoutReducer?.getPayableData?.length === 0 && (
              <p className="noRecordFound">No Record Found</p>
            )}
            {}

            <div className="d-flex justify-content-between">
              <div className="pagination-row">
                {globalReducer?.getTotalCount !== 0 && (
                  <CustomPagination
                    totalCount={globalReducer?.getTotalCount}
                    perPageData={searchFilter?.rows}
                    searchFilter={searchFilter}
                    setSearchFilter={setSearchFilter}
                    apiCall={GetAdvancePaymentFlow}
                    IsPayoutStatus={true}
                  />
                )}
              </div>
            </div>
            <Modal
              isOpen={submitUtr?.isOpen}
              className="modal-add-user-popup   bankDetailwidth"
              overlayClassName="overlay-history-popup network-z-index"
              ariaHideApp={false}
            >
              <BankDetails
                submitUtr={submitUtr}
                setSubmitUtr={setSubmitUtr}
                searchFilter={searchFilter}
              />
            </Modal>
            <Modal
              isOpen={isOpenSetting}
              className=" modal-add-user-popup modal-upload-excel-popup payOutAddHeader"
              overlayClassName="overlay-history-popup network-z-index"
              ariaHideApp={false}
            >
              <AdditionalComponentHeader
                setIsOpenSetting={setIsOpenSetting}
                header={header}
                setHeader={setHeader}
                searchFilter={searchFilter}
              />
            </Modal>

            <Modal
              isOpen={isOpenModelForEdit}
              className=" modal-add-user-popup modal-upload-excel-popup payOutAddHeader"
              overlayClassName="overlay-history-popup network-z-index"
              ariaHideApp={false}
            >
              <AdvancePaymentEditModel
                setIsOpenSetting={setIsOpenModelForEdit}
                rowDetailsChangeHandler={rowDetailsChangeHandler}
                rowDetails={rowDetails}
                OnRowDetailsIndexChangeHandler={OnRowDetailsIndexChangeHandler}
              />
            </Modal>

            <Modal
              isOpen={isHistoryOpen}
              className="modal-history-popup"
              overlayClassName="overlay-history-popup network-z-index"
              ariaHideApp={false}
            >
              <UnlockHistory
                isHistoryOpen={isHistoryOpen}
                setIsHistoryOpen={setIsHistoryOpen}
                historyHeaders={historyHeaders}
                historySearch={historySearch}
                setHistorySearch={setHistorySearch}
                historyApi={AdvancePaymenViewHistory}
              />
            </Modal>
          </div>
        )}
      </div>
    </div>
  );
};
